// api.service.js
import axios from 'axios';
import { API_BASE_URL } from '../config/constants';

const api = axios.create({
    baseURL:API_BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Add request interceptor to include auth token
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

class DashboardApiService {
    constructor(config) {
      this.api = axios.create({
        baseURL: config.apiBaseUrl,
        headers: {
          'Content-Type': 'application/json',
          ...(config.authToken && { 'Authorization': `Bearer ${config.authToken}` })
        }
      });
  
      // Add response interceptor for error handling
      this.api.interceptors.response.use(
        response => response,
        error => {
          if (config.onError) {
            config.onError(error);
          }
          return Promise.reject(error);
        }
      );
    }
  
    // User Activity
    async getUserActivity(userId) {
      try {
        const response = await this.api.get(`/admin/users/${userId}/activity`);
        return response.data;
      } catch (error) {
        console.error('Error fetching user activity:', error);
        throw error;
      }
    }
  
    // Hiring Pipeline
    async getHiringPipeline(userId) {
      try {
        const response = await this.api.get(`/admin/users/${userId}/hiring-pipeline`);
        return response.data;
      } catch (error) {
        console.error('Error fetching hiring pipeline:', error);
        throw error;
      }
    }
  
    // Dashboard Stats
    async getDashboardStats() {
      try {
        const response = await this.api.get('/admin/dashboard/stats');
        return response.data;
      } catch (error) {
        console.error('Error fetching dashboard stats:', error);
        throw error;
      }
    }
  
    // Token Usage
    async getTokenUsage(userId) {
      try {
        const response = await this.api.get(`/admin/users/${userId}/token-usage`);
        return response.data;
      } catch (error) {
        console.error('Error fetching token usage:', error);
        throw error;
      }
    }
  
    // Update User
    async updateUser(userId, userData) {
      try {
        const response = await this.api.put(`/admin/users/${userId}`, userData);
        return response.data;
      } catch (error) {
        console.error('Error updating user:', error);
        throw error;
      }
    }
  
    // Delete User
    async deleteUser(userId) {
      try {
        const response = await this.api.delete(`/admin/users/${userId}`);
        return response.data;
      } catch (error) {
        console.error('Error deleting user:', error);
        throw error;
      }
    }
  }

export default api;
export const createDashboardApi = (config) => {
    return new DashboardApiService(config);
  };